import React from 'react';
import { FDTextInput } from '@facet-wealth/design';
import PropTypes from 'prop-types';
import useMetaLayoutContext from 'Components/UI/Meta/MetaForm/Components/MetaLayoutContext';
import { useDataAttrs } from 'Helpers/Testing';

const getLoginEmailAddressResource = coll => {
  return coll.resources().list().find((resource) => resource.attr('type') === 'login');
};

const getLoginEmailAddress = coll => {
  const resource = getLoginEmailAddressResource(coll);
  if (!resource) {
    return '';
  }

  return resource.attr('address');
};

export const EmailAddressInput = (props) => {
  const {
    collection, FormProps, error, helperTextValue,
  } = props;
  // Well, that was annoying. You can't call onChange on a collection within meta form. Not sure why not.
  // This is a kinda hacky way to get around how meta form works without risking existing uses of Form type attributes.
  // I added onChangeCollection to Form.jsx, and then passed it in through FormProps since that is passed to downstream components.
  // By doing it like this I'm guaranteed that no one else attempts to use this behavior since onChangeCollection is not in the code base.
  const { onChangeCollection } = FormProps;
  const [address, setAddress] = React.useState(getLoginEmailAddress(collection));

  // This shouldn't be in here but this endpoint can go to hell. The client id is already in the query params for the collection self link
  // It shouldn't need to be an attribute as well. I am terrified of trying to resolve that issue so here we are -- This component will only
  // work inside of a meta layout.
  const { resource } = useMetaLayoutContext();

  React.useEffect(() => {
    setAddress(getLoginEmailAddress(collection));
  }, [collection]);

  const dataAttrs = useDataAttrs(props);

  return (
    <FDTextInput
      {...dataAttrs}
      error={error}
      label={'Email Address'}
      flex={1}
      helperText={helperTextValue}
      value={address}
      onChange={(evt) => {
        setAddress(evt.target.value);
      }}
      onBlur={() => {
        // On blur send this to the collection
        let res = getLoginEmailAddressResource(collection);
        if (!res) {
          res = collection.create();
          res.attr('type', 'login');
          collection.resources().pushItem(null, res);
        }

        res.attr('address', address).attr('clientId', resource.id());
        onChangeCollection(collection);
      }}
    />
  );
};

EmailAddressInput.defaultProps = {
  error: undefined,
  helperTextValue: undefined,
};

EmailAddressInput.propTypes = {
  collection: PropTypes.object.isRequired,
  FormProps: PropTypes.object.isRequired,
  error: PropTypes.bool,
  helperTextValue: PropTypes.string,
};
